import React from 'react'
import { Typography } from 'antd'
import { ClockCircleOutlined } from '@ant-design/icons'
import { formatTime, getScheduleTime, getProgressColor } from '../utils/formatters'

const { Text } = Typography

const ProcedureProgress = ({ theatre, elapsed, remaining, progress }) => {
  return (
    <>
      <div style={{ marginBottom: '16px' }}>
        <Text strong>Current Procedure: </Text>
        <Text>{theatre.currentProcedure}</Text>
      </div>
      <div style={{ marginBottom: '8px' }}>
        <ClockCircleOutlined style={{ marginRight: '8px' }} />
        <Text>Started: </Text>
        <Text>{getScheduleTime(theatre.startTime)}</Text>
        <Text style={{ marginLeft: '8px' }}>({formatTime(elapsed)} elapsed)</Text>
      </div>

      {/* Progress bar */}
      <div style={{ marginBottom: '16px' }}>
        <div
          style={{
            height: '12px',
            background: '#f0f0f0',
            borderRadius: '6px',
            overflow: 'hidden'
          }}
        >
          <div
            style={{
              height: '100%',
              width: `${progress}%`,
              background: getProgressColor(progress),
              transition: 'width 0.3s ease'
            }}
          />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '4px' }}>
          <Text type='secondary' style={{ fontSize: '12px' }}>
            {formatTime(elapsed)} / {formatTime(elapsed + remaining)}
          </Text>
          <Text
            style={{
              fontSize: '12px',
              color: progress > 80 ? '#f5222d' : 'inherit'
            }}
          >
            {formatTime(remaining)} remaining
          </Text>
        </div>
      </div>
    </>
  )
}

export default ProcedureProgress
